import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isEmpty, uniqueId } from 'lodash'
import useOurCultureGallery from './useOurCultureGallery'
import { motion } from 'framer-motion'
import { getValue } from '../Hero/functions'
import Skeleton from './components/Skeleton'
import Button from '@/components/shared/components/Button/Button'

import './stytes.scss'

OurCultureGallery.propTypes = {
  data: PropTypes.object,
}

const variants = {
  enter: ({ direction }) => {
    return {
      x: direction > 0 ? '100%' : '-100%',
      opacity: 1,
    }
  },
  center: () => {
    return {
      x: 0,
      opacity: 1,
      translateX: 0,
    }
  },
  exit: ({ direction }) => {
    return {
      x: direction > 0 ? '-100%' : '100%',
      opacity: 0.2,
    }
  },
}

const activeColor = '#1B1F24'

export default function OurCultureGallery({ data }) {
  const { onPrevButtonClick, onNextButtonClick, imageContent, emblaRef, slides, indexOnFocus } =
    useOurCultureGallery({ data })
  const [direction, setDirection] = useState(1)

  if (isEmpty(data)) return <Skeleton />

  return (
    <section className="our-culture-galery my-36 lg:my-40">
      <div className="main-container flex flex-col mb-8">
        <span className="paragraph text-[20px] uppercase block leading-none mb-1">
          {data?.label}
        </span>
        <h4 className="heading3 text-[45px] md:text-[62px] 2xl:text-[70px] leading-none uppercase">
          {data?.title}
        </h4>
      </div>

      <div className="embla">
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container">
            {slides?.map((item, index) => {
              const key = uniqueId()

              const slide = item?.slide
              const image = slide?.image

              const isCurrent = index === indexOnFocus

              return (
                <div key={key} className="embla__slide embla__class-names">
                  <motion.img
                    custom={{ direction, isCurrent }}
                    variants={variants}
                    initial="enter"
                    animate={'center'}
                    exit="exit"
                    transition={{
                      opacity: {
                        duration: 0.2,
                      },
                      duration: 1,
                    }}
                    src={image?.url}
                    alt={getValue(image?.alt)}
                    title={getValue(image?.title)}
                    description={getValue(image?.description)}
                    caption={getValue(image?.caption)}
                    author={getValue(image?.author)}
                    className={`embla__slide__img`}
                  />
                </div>
              )
            })}
          </div>
        </div>

        <div className="mx-auto embla__slide max-h-[150px] md:max-h-[65px] mt-[24px]">
          <div className="flex flex-col md:flex-row md:justify-between gap-6">
            <div
              style={{
                visibility: !isEmpty(imageContent) ? 'visible' : 'hidden',
              }}
            >
              <span className="paragraph text-[18px] uppercase">{imageContent?.caption}</span>
              <h4 className="heading4 text-[30px] uppercase">{imageContent?.title}</h4>
            </div>

            <div className="embla__buttons">
              <Button
                action={() => {
                  setDirection(-1)
                  onPrevButtonClick()
                }}
                type="icon"
                icon="ArrowLeft"
                iconFill="transparent"
                iconStroke={activeColor}
                strokeCircle={activeColor}
                strokeOnHover={'#fff'}
              />
              <Button
                action={() => {
                  setDirection(1)
                  onNextButtonClick()
                }}
                type="icon"
                icon="ArrowRight"
                iconFill="transparent"
                iconStroke={activeColor}
                strokeCircle={activeColor}
                strokeOnHover={'#fff'}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
